import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  IconButton,
  Modal as MuiModal,
  Stack,
  Typography,
} from "@mui/material";
import type React from "react";
import { useState } from "react";

interface ModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onSubmit: () => Promise<void>;
  submitDisabled?: boolean;
  header: string;
  size: "md";
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onCancel,
  onSubmit,
  submitDisabled,
  header,
  children,
}) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await onSubmit();
      setLoading(false);
    } catch (_error) {
      setLoading(false);
    }
  };

  return (
    <MuiModal
      open={isOpen}
      onClose={onCancel}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Stack
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80vw",
          maxHeight: "90vh",
          backgroundColor: (theme) => theme.palette.background.paper,
          borderRadius: 1,
          padding: 4,
        }}
        spacing={4}
      >
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="h5">{header}</Typography>
          <IconButton onClick={onCancel}>
            <CloseIcon />
          </IconButton>
        </Stack>

        {children}

        <Stack
          direction={"row"}
          spacing={2}
          justifyContent={"flex-end"}
          justifySelf={"flex-end"}
        >
          <Button variant="outlined" onClick={onCancel} disabled={loading}>
            Cancel
          </Button>
          <LoadingButton
            variant="contained"
            loading={loading}
            onClick={handleSubmit}
            disabled={submitDisabled}
          >
            Submit
          </LoadingButton>
        </Stack>
      </Stack>
    </MuiModal>
  );
};
